import type { UpdateLicenseTranscriptUnlockTypeBodyDto } from 'app/API';

export type TTranscriptUnlockType = UpdateLicenseTranscriptUnlockTypeBodyDto['transcriptUnlockType'];

const TRANSCRIPT_UNLOCK_TYPES: readonly string[] = [
  'ASONE_ENHANCED',
  'SESSION_TEXT',
  'CHOOSE',
] satisfies TTranscriptUnlockType[];

export const isTranscriptUnlockType = (value: string): value is TTranscriptUnlockType =>
  TRANSCRIPT_UNLOCK_TYPES.includes(value);
